// extracted by mini-css-extract-plugin
module.exports = {"title":"Cart_title__HlPgz","border":"Cart_border__3Gshe","header":"Cart_header__3wQSQ","decoration":"Cart_decoration__3GGSX"};